import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './index.css';
import { Portal } from './portal';

import type { JSX } from 'react';

interface IPopupContentParams {
  onClose(): void;
}
interface IPopupMobileOwnProps {
  popupContent(params: IPopupContentParams): JSX.Element;
  animation?: 'scale' | 'opacity' | 'toggle-bottom';
  onOpen?(): void;
}

type TPopupMobileProps = React.PropsWithChildren<IPopupMobileOwnProps>;

enum EOpened {
  NONE,
  TRANSITION,
  FINISHED,
}
interface IPopupMobileState {
  opened: EOpened;
}

export class PopupMobile extends React.Component<TPopupMobileProps, IPopupMobileState> {
  public state = {
    opened: EOpened.NONE,
  };

  private isSwiped = false;

  public render() {
    const { animation = 'scale', children, popupContent } = this.props;

    const { opened } = this.state;

    const showContent = opened !== EOpened.NONE;

    return (
      <>
        <Portal>
          <div
            {...mergeStyles(
              styles['container'],
              animation === 'scale' && styles['animation--scale'],
              showContent && animation === 'opacity' && styles['animation--opacity'],
              showContent && animation === 'toggle-bottom' && styles['animation--toggle_bottom'],
              opened === EOpened.FINISHED && styles['opened'],
            )}
          >
            <div className={styles['content']}>{showContent && popupContent({ onClose: this.onClose })}</div>
          </div>
        </Portal>
        <div
          onMouseUp={this.onOpen}
          onTouchStart={() => (this.isSwiped = false)}
          onTouchMove={() => (this.isSwiped = true)}
          onTouchEnd={this.onOpen}
        >
          {children}
        </div>
      </>
    );
  }

  private onClose = () => {
    this.setState({ opened: EOpened.TRANSITION });
    setTimeout(() => {
      this.setState({ opened: EOpened.NONE });
    }, 300);
  };

  private onOpen = () => {
    if (this.isSwiped) {
      return;
    }
    if (this.props.onOpen) {
      this.props.onOpen();
    }
    this.setState({ opened: EOpened.TRANSITION });
    setTimeout(() => {
      this.setState({ opened: EOpened.FINISHED });
    }, 300);
  };
}
